import { LifeCycle } from "../lifecycle.model";

export class FileRecord {
	public id: string;
	public type: FileType;
	public name: string;
	public size: string;
	public lifeCycle: LifeCycle;
}

export type FileType =
	'original-file' |
	'extracted-html-file' |
	'incoming-production-image' |
	'incoming-production-text' |
	'normalized-tiff' |
	'normalized-pdf' |
	'normalized-translated-file' |
	'redaction-image' |
	'redacted-pdf' |
	'annotation-image' |
	'annotated-pdf' |
	'transcribed-file' |
	'image-label-file' |
	'entity-analysis-file' |
	'incoming-production-pdf' |
	'outgoing-production-image' |
	'outgoing-production-bates-stamped-pdf' |
	'outgoing-production-text' |
	'outgoing-production-loadfile-lexbe' |
	'outgoing-production-loadfile-summation' |
	'outgoing-production-loadfile-piped-separated-values' |
	'outgoing-production-loadfile-concordance' |
	'outgoing-production-image-load-file' |
	'outgoing-production-loadfile-tab-separated-values' |
	'outgoing-production-placeholder-original' |
	'outgoing-production-withheld-log' |
	'legacy-download-zip' |
	'outgoing-briefcase-bates-stamped-pdf' |
	'outgoing-briefcase-redacted-pdf' |
	'outgoing-briefcase-pdf-merged' |
	'outgoing-briefcase-redacted-merged' |
	'outgoing-briefcase-annotated-pdf' |
	'outgoing-briefcase-annotated-merged' |
	'outgoing-briefcase-zipped' |
	'archive-image' |
	'archive-text' |
	'archive-job-loadfile-lexbe' |
	'archive-job-loadfile-summation' |
	'archive-job-loadfile-piped-separated-values' |
	'archive-job-loadfile-concordance' |
	'archive-job-image-log-file' |
	'archive-job-loadfile-tab-separated-values';
